import {Chip} from "@mui/material";
import {getLabelEstado} from "../../shared/estados";

function LabelEstado({estado, label}) {
    if (!estado) return null;

    let color;

    switch (estado) {
        case "AGUARDANDO_APROVACAO":
            color = "info";
            break;
        case "EM_FILA":
            color = "default";
            break;
        case "PROCESSAMENTO":
            color = "warning";
            break;
        case "PROCESSADO_COM_SUCESSO":
            color = "success";
            break;
        case "PROCESSADO_COM_ERRO":
            color = "error";
            break;
        case "RESULTADO_INDETERMINADO":
            color = "warning";
            break;
        default:
            color = "default";
    }

    return (
        <Chip
            label={label || getLabelEstado(estado)}
            variant="outlined"
            size="small"
            color={color}
            sx={{
                marginX: 2
            }}
        />
    );
}

export default LabelEstado;
